import { render } from "./dialog-threshold.vue?vue&type=template&id=773c7698&scoped=true"
import script from "./dialog-threshold.vue?vue&type=script&lang=js"
export * from "./dialog-threshold.vue?vue&type=script&lang=js"

import "./dialog-threshold.vue?vue&type=style&index=0&id=773c7698&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-773c7698"]])

export default __exports__